import React from 'react'
import './Login.css'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import feelsLogo from '../../Components/icons/feelsLogo.png'

export default function LoginLayout({ children }) {
  return (
    <>
      <div className="parent-login-container">
        <div className="login-container">
          <img id="login-logo" height="45px" src={feelsLogo} alt="logo" />
          <div>
            <h1 className="login-welcome-text" style={{ color: 'white' }}>
              Welcome to Feels Artist Studio & Tools
            </h1>
          </div>

          {children}

          <div className="links_section">
            <Link
              to={'https://artists.feelsmusic.com/help'}
              id="setUp-link"
            >
              If your team already exists, ask an admin for access.
            </Link>
            <Link
              to={'https://artists.feelsmusic.com/help'}
              id="setUp-link"
            >
              Need Help?
            </Link>
          </div>
        </div>

        <div className="bottom-links">
          <Link to={'https://mmuf-auth-demo.web.app/privacy-policy'}>
            Privacy Policy
          </Link>
          <Link to={'https://mmuf-auth-demo.web.app/terms-of-service'}>
            Terms of Service
          </Link>
        </div>
      </div>
    </>
  )
}

LoginLayout.propTypes = {
  children: PropTypes.node,
}
